import React from "react";
import WeekIntroBlock from "./WeekIntroBlock";
import "./WeekIntroPage.css";

export default function WeekIntroPage({
  weekNumber,
  weekIntro,
  onStartWeek,
  starting,
  actionLabel = "Start Week",
}) {
  return (
    <div className="week-intro-page">
      <div className="week-intro-page__card">
        <div className="week-intro-page__kicker">Week {weekNumber}</div>
        <h1 className="week-intro-page__title">
          {weekIntro?.title || `Week ${weekNumber} Introduction`}
        </h1>

        <WeekIntroBlock weekIntro={weekIntro} />

        <div className="week-intro-page__actions">
          <button
            type="button"
            className="lp-btn lp-primary"
            onClick={onStartWeek}
            disabled={starting}
          >
            {starting ? "Starting..." : actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
